
<ciciam-frame-front>
  <ciciam-form-reset-password (credential)="onResetPassword($event)" #resetpassword></ciciam-form-reset-password>
</ciciam-frame-front>
